<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true;
				})
			}
		},
		mounted() {

		}
	}
</script>

<style>
	#app {
		font-family: Helvetica, sans-serif;
		height: 100%;
	}

	* {
		padding: 0;
		margin: 0;
	}

	body,
	html {
		margin: 0;
		padding: 0;
		height: 100%;
		width: 100%;
		background-color: #EFF1F4;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue